import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMedal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMedal"><Path d="M16.5 15.5V22.25L12 20.25L7.5 22.25V15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 9C19.5 11.4534 18.322 13.6317 16.5007 15C15.2471 15.9419 13.6887 16.5 12 16.5C7.85786 16.5 4.5 13.1421 4.5 9C4.5 4.85786 7.85786 1.5 12 1.5C16.1421 1.5 19.5 4.85786 19.5 9Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMedal;
